import { ConfirmPopup } from "@/components";
import type { ConfirmPopupOptions } from "@/components/ConfirmPopup.vue";
import { App, createApp } from "vue";

interface AlertPlugin {
  install: (app: App) => void;
}

export interface AlertFunction {
  (options: ConfirmPopupOptions): void;
}

// The alert plugin is a Vue.js plugin that provides a global alert function
// that can be used to show a confirm popup anywhere in the app.
export const alertPlugin: AlertPlugin = {
  install(app) {
    const container = document.createElement("div");
    container.id = "__alert_container";
    document.body.appendChild(container);
    const alertApp = createApp(ConfirmPopup).mount(container);

    const alert: AlertFunction = (options: ConfirmPopupOptions) => {
      alertApp.alert(options);
    };
    // use $alert to access the alert function anywhere in the app from the
    // template
    app.config.globalProperties.$alert = alert;
  },
};
